import React from "react";
import { NavLink } from "react-router-dom";
import { policyGroups } from "../config/policyLinks";
import siteConfig from "../config/siteConfig";
import PageMeta from "./PageMeta";
import "../css/policy.scss";

const PolicyLayout = ({ eyebrow = "Customer care", title, intro, sections }) => (
  <main className="policy-page">
    <PageMeta title={title} description={intro} />
    <section className="policy-hero">
      <div className="container policy-hero__inner">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{intro}</p>
        <p className="policy-updated">Last updated {siteConfig.policyEffectiveDate}</p>
      </div>
    </section>
    <div className="container policy-layout">
      <aside className="policy-nav" aria-label="Customer care pages">
        <NavLink className="policy-nav__home" to="/policies">All policies</NavLink>
        {policyGroups.map((group) => (
          <div className="policy-nav__group" key={group.title}>
            <p>{group.title}</p>
            {group.links.map((link) => (
              <NavLink
                className={({ isActive }) => (isActive ? "is-active" : undefined)}
                to={link.to}
                key={link.to}
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        ))}
      </aside>
      <div className="policy-content">
        {sections.map((section, sectionIndex) => (
          <section key={`${section.title}-${sectionIndex}`}>
            <h2>{section.title}</h2>
            {section.body.map((paragraph, paragraphIndex) => (
              <p key={`${section.title}-paragraph-${paragraphIndex}`}>{paragraph}</p>
            ))}
            {section.items && (
              <ul>
                {section.items.map((item, itemIndex) => (
                  <li key={`${section.title}-item-${itemIndex}`}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    </div>
  </main>
);

export default PolicyLayout;
